import * as EmailValidator from "email-validator";
import {useState} from "react";

import "../styles.scss";

function Project({ title, subtitle, sidebar, url, imageName, imagePosition, disabled}) {
  return (
    <li className={disabled ? "Disabled" : ""}>
      <a href={url}>
        <h3 dangerouslySetInnerHTML={{ __html: title }} />
        <p>{subtitle}</p>
      </a>

      <style jsx>{`
        li {
          background-image: url(/static/images/${imageName}${sidebar
              ? "-mobile"
              : ""}.svg);
          background-position: ${imagePosition || "center left"}
        }
        @media (max-width: 1023px) {
          li {
            background-image: url(/static/images/${imageName }-mobile.svg);
          }
        }
      `}</style>
    </li>
  );
}

function Notes({ label, mobileLabel, children }) {
  return (
    <>
      {mobileLabel && <h2 className="narrowOnly">{mobileLabel}</h2>}
      {label !== null && (
        <h2 className={mobileLabel ? "wideOnly" : ""}>{label || "Notes"}</h2>
      )}
      <ol className="Notes">{children}</ol>
    </>
  );
}

function Note({ title, subtitle, url, active, disabled }) {
  return (
    <li className={`${active ? "Active" : ""} ${disabled ? "Disabled" : ""}`}>
      <a href={url}>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </a>
    </li>
  );
}

export function Controls() {
  const [emailAddress, setEmailAddress] = useState(null);
  return (
    <div className="Controls">
      <div className="LinkContainer">
      <a href="mailto:andy@andymatuschak.org">Email</a>
      <a href="https://twitter.com/andy_matuschak">Twitter</a>
      </div>
      <div className="MailingListContainer">
      <label htmlFor="email">Want to hear about new work by email?</label>
      <form action="https://tinyletter.com/andymatuschak" method="post" target="popupwindow" onSubmit="window.open('https://tinyletter.com/andymatuschak', 'popupwindow', 'scrollbars=yes,width=800,height=600');return true"><input type="hidden" value="1" name="embed"/>
      <input
        type="text"
        name="email"
        placeholder="Enter your email address"
        size="1"
        onChange={(event) => setEmailAddress(event.target.value)}
        value={emailAddress}
      />
      <button type="submit" disabled={!emailAddress || !EmailValidator.validate(emailAddress)}>
        Subscribe
      </button>
      </form>
      </div>
    </div>
  );
}

export default ({ sidebar }) => (
  <div className={`SectionList ${sidebar ? "Sidebar" : "NotSidebar"}`}>
    <div className="BeginningBGExtender" />
    <section className="Meta">
      <div className="MetaContent">
        <div className="NameAndButtons">
          <h1><a href="/">Andy Matuschak</a></h1>
          <div className="HeaderButtons narrowOnly">
            <a href="mailto:andy@andymatuschak.org">Email</a>
            <a href="https://twitter.com/andy_matuschak">Twitter</a>
          </div>
        </div>
        <p className="narrowOnly">
          Hi! I’m a software engineer, designer, and researcher. I work on
          technologies that expand what people can think and do.
        </p>
        <div className="wideOnly">
          <p>
            Hi! I’m a software engineer, designer, and researcher. I work on
            technologies that expand what people can think and do.
          </p>
          <p>
            I explore ideas by expressing them in real-world systems, juggling
            approaches from industry and academia to seek insights they can&rsquo;t see alone. Thinking through making.
          </p>
          <p>
            My current work follows five years at{" "}
            <a href="http://khanacademy.org">Khan Academy</a>, where I led <a href="http://early.khanacademy.org">the R&D group</a>, which I co-founded with my friend <a href="http://www.maylikhoe.com">May-Li Khoe</a>.</p>
          <p>
            Before that, I
            helped build iOS at Apple, focusing on
            foundations like multitouch, animation, and inter-app
            coordination.
          </p>
        </div>
      </div>
        {!sidebar && <div className="wideOnly" style={{flexShrink: 0}}><Controls /></div>}
    </section>

    <section>
      <header>
        <h1>Tools for thought</h1>
        <p className="wideOnly">
          What comes after the book? Weaving new media from
          ideas in cognitive science; using those systems to better see cognition.
        </p>
        <p className="narrowOnly">What comes after the book?</p>
      </header>
      <ol className="MajorProjects">
        <Project
          title={`<span class="alternateGlyph">Q</span>uantum Country`}
          subtitle="An experiment in a new medium, making it easy to remember what you read"
          sidebar={sidebar}
          url="https://quantum.country"
          imageName="quantum-country"
          imagePosition="center left"
        />
      </ol>
      <Notes label="Notes">
        <Note
          title="Why books don&rsquo;t work"
          subtitle="Designing media to reflect how people think and learn"
          url="/books"
          active={!!sidebar}
        />
        <div className="narrowOnly">
        <Note
          title="more soon…"
          disabled
        />
        </div>
      </Notes>
    </section>

    <section>
      <header>
        <h1>Exploratory ed-tech</h1>
        <p className="wideOnly">
          Work from my time at{" "}
          <a href="https://khanacademy.org">Khan Academy</a>, where{" "}
        <a href="https://early.khanacademy.org">my team</a> worked with teachers to invent novel
          interactive learning environments.
        </p>
        <p className="narrowOnly">
          Creations from my time at{" "}
          <a href="https://khanacademy.org">Khan Academy</a>.
        </p>
      </header>
      <ol className="MajorProjects">
        <Project
          title="Building complex skills online"
          subtitle="Beyond right and wrong: scalable open-ended learning activities"
          sidebar={sidebar}
          url="https://early.khanacademy.org/open-ended"
          imageName="free-response"
          imagePosition="center right"
        />
        <Project
          title="Numbers at play"
          subtitle="Designing digital manipu&shy;latives to reveal numbers&rsquo; hidden properties"
          sidebar={sidebar}
          url="https://early.khanacademy.org/cantor"
          imageName="cantor"
          imagePosition="center right"
        />
        <Project
          title="Playful worlds of creative math"
          subtitle="Reframing early numeracy around adventure, wonder, and creativity"
          sidebar={sidebar}
          url="https://early.khanacademy.org/early-math"
          imageName="early-math"
          imagePosition="bottom right"
        />
      </ol>
      <Notes label="Research Blog" mobileLabel="Blog">
        <Note
          title="Narrated explorables: three mental models"
          subtitle="When author and learner share a canvas"
          url="https://medium.com/khan-academy-early-product-development/narrated-explorables-three-mental-models-e16e0d80e4c1"
        />
        <Note
          title="Students are the subjects of our sentences"
          subtitle="A syntactic trick to emphasize student agency"
          url="https://medium.com/khan-academy-early-product-development/the-student-is-the-most-important-subject-in-our-sentences-2aba3fc58279"
        />
        <Note
          title="Looking sideways at the design squiggle"
          subtitle="Reflections on the team's design process"
          url="https://medium.com/khan-academy-early-product-development/looking-sideways-at-the-design-squiggle-9bab49d1c2de"
        />
        <Note
          title="Mastery learning and creative tasks"
          subtitle="Mastery learning's limits for complex skills"
          url="https://medium.com/khan-academy-early-product-development/mastery-learning-and-creative-tasks-97c4a11f8364"
        />
        <Note
          title="Sorting product &ldquo;baseball cards&rdquo;"
          subtitle="Bridging behavioral interviews and prototypes"
          url="https://medium.com/khan-academy-early-product-development/sorting-product-baseball-cards-bridging-behavioral-interviews-and-prototypes-510057967cf"
        />
        <Note
          title="Explanations from &lsquo;masters&rsquo; of geometry"
          subtitle="The gulf between application and explanation"
          url="https://medium.com/khan-academy-early-product-development/explanations-from-alleged-masters-of-shape-dissection-8ebed962b2d9"
        />
        <Note
          title="Safely showing students peers&rsquo; comments"
          subtitle="Designing peer interactions to avoid abuse"
          url="https://medium.com/khan-academy-early-product-development/safely-showing-students-how-others-see-their-work-e6d779b2da2c"
        />
        <Note
          title="Games vs. education on unguided instruction"
          subtitle="The limits of teaching without words"
          url="https://klr.tumblr.com/post/159583871898/game-designers-vs-education-researchers-on"
        />
        <Note
          title="Rich tasks which crowdsource more rich tasks"
          subtitle="Using student work to arrange social learning"
          url="https://klr.tumblr.com/post/158036182833/rich-tasks-crowdsourcing-data-for-more-rich-tasks"
        />
        <Note
          title="Surveying the open-ended task landscape"
          subtitle="Notes from literature / market review"
          url="https://klr.tumblr.com/post/156063609578/surveying-the-open-ended-response-landscape"
        />
        <Note
          title="Amplifying open-ended questions"
          subtitle="Enabling open-ended online learning activities"
          url="https://klr.tumblr.com/post/153878272318/amplifying-open-ended-questions"
        />
        <Note
          title="One medium, many contexts"
          subtitle="Designing math manipulatives for fluid use"
          url="https://klr.tumblr.com/post/154133471528/listening-to-educators-listening-to-students"
        />
        <Note
          title="Old and new ways of looking at numbers"
          subtitle="Making abstract properties more visible"
          url="https://klr.tumblr.com/post/149677916243/old-and-new-ways-of-looking-at-numbers"
        />
        <Note
          title="A medium for exploring quantity"
          subtitle="Introducing our math manipulative project"
          url="https://klr.tumblr.com/post/147245626988/a-medium-supporting-the-exploration-of-quantities"
        />
        <Note
          title="Student agency and flow"
          subtitle="Helping students surf their learning edge"
          url="https://klr.tumblr.com/post/146190595653/student-agency-and-flow"
        />
      </Notes>
    </section>

    <section>
      <header>
        <h1>Natively&#8209;dynamic interfaces</h1>
        <p className="wideOnly">
          I&rsquo;m fascinated by interfaces which can&rsquo;t be designed through pictures: native to the dy&shy;namic medium, only designable with code.
        </p>
        <p className="narrowOnly">Designs which can only be explored with code.</p>
      </header>
      <ol className="MajorProjects">
        <Project
          title="Scrying Pen"
          subtitle="A pen which draws its own future using a realtime recurrent neural network"
          sidebar={sidebar}
          url="/scrying-pen"
          imageName="scrying-pen"
          imagePosition="center right"
        />
        <Project
          title="iOS's parallax system"
          subtitle="A realtime illusion of 3D depth using the device's gyro and accelerometer"
          sidebar={sidebar}
          disabled
          imageName="coming-soon"
          imagePosition="center right"
        />
        <Project
          title="iOS's edge-swipe gestures"
          subtitle="Balancing uncertainty and responsiveness in multitouch interfaces"
          sidebar={sidebar}
          disabled
          imageName="coming-soon"
          imagePosition="center right"
        />
        <Project
          title="iOS's 3-D page curl"
          subtitle="Turning a virtual 3D page with your finger"
          sidebar={sidebar}
          disabled
          imageName="coming-soon"
          imagePosition="center right"
        />
      </ol>
    </section>

    <section>
      <header>
        <h1>Meta</h1>
        <p className="wideOnly">
          Brief reflections on how I approach making and thinking.
        </p>
        <p className="narrowOnly">Brief reflections on making and thinking.</p>
      </header>
      <Notes label={null}>
        <Note
          title="Exalting data, missing meaning"
          subtitle="The delusions of measurement absent theory"
          url="https://blog.andymatuschak.org/post/159340765257/exalting-data-missing-meaning"
        />
        <Note
          title="Satisfaction and progress in open-ended work"
          subtitle="Seeking gradient in the fog of novel work"
          url="https://blog.andymatuschak.org/post/159979927467/satisfaction-and-progress-in-open-ended-work"
        />
        <Note
          title="Building habits via smoothly ratcheting targets"
          subtitle="A surprisingly reliable strategy for starting habits"
          url="https://blog.andymatuschak.org/post/169043084412/successful-habits-through-smoothly-ratcheting"
        />
      </Notes>
    </section>

    <section className="narrowNonSidebarOnly">
      <Controls />
    </section>

    <div className="EndingBGExtender" />
  </div>
);
